import styled from 'styled-components';
import FullScreenContainer from 'components/fullScreenContainer';

export const Container = styled(FullScreenContainer)`
  padding: 0;
`;
